import axios from "axios";
import { useMutation, useQueryClient } from "react-query";
import { useGenErrorMsgBanners } from "../../../utils/useGenErrorMsgBanners";

export const useBulkDeleteContent = () => {
   const { genErrorMsgBanners } = useGenErrorMsgBanners();
   const queryClient = useQueryClient();

   return useMutation(
      ({ contentType, contentIds }) => {
         return axios.post(
            `/api/content/bulkDeleteContent/${contentType}`,
            { contentIds },
            { headers: { "Content-Type": "application/json" } }
         );
      },
      {
         onError: (err) => {
            genErrorMsgBanners({ err });
         },
         onSuccess: (
            res,
            { contentType }
         ) => {
            queryClient.invalidateQueries(["contentListing", "lazy", [contentType]]);
         },
      }
   );
};
